import React from 'react';
import { Layout, Button } from 'antd';
import styles from './css/Error.module.css'
import { Header, Footer, FormMessage } from './CorePageContents';
import * as CONSTANTS from '../../constants/constants';

const { Content } = Layout;

export const PrimePermissionError = () => {

  // スキルマップマニュアルページを新規タブで開く
  const openManualClick = () => {
    window.open(CONSTANTS.URL_SMS_MANUAL);
  }

  return (
    <Layout>
      <Header />
      <Content>
        <div className={styles.mainMessage}>利用権限をご確認ください</div>
        <br />
        <div className={styles.subMessage}>この操作を行うための権限が、お客様のアカウントに付与されておりません。<br />
          スキルマップサイトの各機能をご利用いただくには、<br />
          貴社の企業担当者（管理者）様による権限設定が必要となります。
          <br />
          <br />
          大変お手数ですが、貴社の企業担当者様へご連絡いただき、<br />
          必要な利用権限の付与をご依頼くださいますようお願いいたします。
          <br />
          <br />
          また、スキルマップサイトの操作マニュアルをご用意しています。<br />
          ご不明な点がありましたらマニュアルをご確認ください。
          <br />
          <br />
        </div>
        <Button
          className={styles.primeSysButton}
          onClick={openManualClick}
        >
          マニュアルを見る
        </Button>
        <br />
        <FormMessage />
      </Content>
      <Footer />
    </Layout>
  );
}
